import { Injectable, signal, effect, NgZone, inject, OnDestroy, Injector } from '@angular/core';
import { Router } from '@angular/router';
import { AuthAdminStore } from '../state/auth-admin-store';
import { fromEvent, merge, Subscription, throttleTime } from 'rxjs';

@Injectable({ providedIn: 'root' })
export class InactivitySessionUtil implements OnDestroy {

    private readonly router = inject(Router);
    private readonly ngZone = inject(NgZone);
    private readonly injector = inject(Injector);

    public lastActivity = signal(Date.now());
    public readonly TIMEOUT = 30 * 60 * 1000; // 30 minutos
    
    private timeoutId?: any;
    private eventSubscription?: Subscription;

    constructor() {
        
        effect(() => {
            const timestamp = this.lastActivity();
            const elapsed = Date.now() - timestamp;
            
            if (this.timeoutId) clearTimeout(this.timeoutId);

            this.ngZone.runOutsideAngular(() => {
                const remaining = this.TIMEOUT - elapsed;
                if (remaining <= 0) {
                    this.ngZone.run(() => this.logout());
                } else {
                    this.timeoutId = setTimeout(() => {
                        this.ngZone.run(() => this.logout());
                    }, remaining);
                }
            });
        });
    }

    startWatching() {
       
        this.stopWatching();

        const events = ['click', 'mousemove', 'keydown', 'scroll', 'touchstart'];
        const activity$ = merge(...events.map(e => fromEvent(window, e)));

        this.eventSubscription = activity$.pipe(
            throttleTime(5000)
        ).subscribe(() => {
            this.resetTimer();
        });
    }

    resetTimer() {
        this.lastActivity.set(Date.now());
    }

    private logout() {
        this.stopWatching();
        
        const authStore = this.injector.get(AuthAdminStore);
        authStore.logout();
        
        this.router.navigate(['/login']);
    }

    stopWatching() {
        if (this.timeoutId) clearTimeout(this.timeoutId);
        if (this.eventSubscription) {
            this.eventSubscription.unsubscribe();
            this.eventSubscription = undefined;
        }
    }

    ngOnDestroy() {
        this.stopWatching();
    }
}
